export default {
    ADMIN : 'admin',
    USER  : 'user',
    HR    : 'hr',
    PUBLIC: 'public'
}